import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_ONLINE_BANKING_CHILD: MijnRoute = {
    path: 'online-bankieren-kind',
    navigationEvent: 'toOnlineBankierenKind',
    regex: /^\/zelf-regelen\/online-bankieren-kind$/,
    webcomponent: 'mijn-klant-zelfservice-webcomponent',
    internalPath: '/online-bankieren-kind'
};
